import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    colors: [],
    isLoading: false,
};

const colorSlice = createSlice({
    name: "color",
    initialState,
    reducers: {
        setColors: (state, action) => {
            state.colors = action.payload;
        },
        setLoading: (state, action) => {
            state.isLoading = action.payload;
        },
        addColor: (state, action) => {
            state.colors.unshift(action.payload);
        },
        updateColor: (state, action) => {
            const i = state.colors.findIndex(c => c._id === action.payload._id);
            if (i !== -1) state.colors[i] = action.payload;
        },
        removeColor: (state, action) => {
            state.colors = state.colors.filter(c => c._id !== action.payload);
        },

    }
});

export const { setColors, setLoading, addColor, updateColor, removeColor } = colorSlice.actions;
export const ColorReducer = colorSlice.reducer;